import { render, staticRenderFns } from "./FooterPrimary.vue?vue&type=template&id=40b3fd97&scoped=true&"
import script from "./FooterPrimary.vue?vue&type=script&lang=js&"
export * from "./FooterPrimary.vue?vue&type=script&lang=js&"
import style0 from "./FooterPrimary.vue?vue&type=style&index=0&id=40b3fd97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3fd97",
  null
  
)

export default component.exports